/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import { Breadcrumbs, Link, Toolbar, Typography } from '@mui/material';
import { useParams, useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getArticlesById, getProductByTid } from '@ivymobi/orbit-core/business/productCenter';
import { Link as RouteLink } from 'react-router-dom';
import { TenantContext, UserContext } from '../../orbit-context';
import { connect, useSolutionContext } from '../context';
import classnames from 'classnames';
import { isPhone, isIPad } from '../../selection/utils';
import * as styles from './index.module.scss';
import _ from 'lodash';
import { web2dData } from '../data-source';

const Preview2DDetail = () => {
  const { id } = useParams<any>() ?? { id: null };
  const history = useHistory();
  const dispatch = useDispatch();
  const tenant = React.useContext(TenantContext);
  const { openDialog } = useSolutionContext();
  const category = web2dData?.[id];
  const bgImageRef = React.useRef(null);
  const hotspotscontainerRef = React.useRef(null);
  console.log('category ===>>', category);

  /*
  const relatedPIDObj = {};

  category && category.products && (typeof (category.products) === 'object') && category.products.map((product, index) => {
    if (typeof (product) === 'object') {
      relatedPIDObj[product._id] = [];
      if (product.addition && (product.addition.length > 0)) {
        const pidArr = product.addition[0].content.replace('<p>', '').replace('</p>', '').split(',');
        _.each(pidArr, (pid, index) => {
          relatedPIDObj[product._id].push(pid);
        });
      }
    }
  });

  const _tmpRelatedPObj = {};
  _.map(relatedPIDObj, (val, key) => {
    _tmpRelatedPObj[key] = [];
    if (val && val.length > 0) {
      _.each(val, (pid, index) => {
        const t = products.byId[pid];
        // getItem && !_.get(products.byId[pid], 'loaded') && getItem(pid)
        _tmpRelatedPObj[key][index] = (typeof products.byId[pid] === 'undefined') ? {} : products.byId[pid];
      });
    }
  });

  category && category.products && (typeof (category.products) === 'object') && category.products.map((product, index) => {
    if (typeof (product) === 'object') {
      product.relatedPList = _tmpRelatedPObj[product._id];

      if (product && product.overviewName) {
        let coordinate0 = product.overviewName.split(',');
        if (coordinate0.length !== 2) {
          coordinate0 = product.overviewName.split('，');

          if (coordinate0.length !== 2) return;
        }
        product.coordinateData = {
          'x': +coordinate0[0] || 0,
          'y': +coordinate0[1] || 0
        };
      }
    }
  });
  */

  const handleClickFlag = (product) => {
    console.log('click flag product = ', product);
    if (product && product.belongTo.length > 0) {
      const belongTo = product.belongTo[0] // 这个就是文章 id
      dispatch(getArticlesById({ user: { token: null, user: null }, tenant: { id: tenant.id }, id: belongTo })).then((res) => {
        console.log("======res===", res)
        if (res && res.data && res.data[0]) {
          console.log('文章详情（暂时没有产品列表，测试数据见上面的 testData ） = ', res.data[0])
          openDialog(res.data[0]);
        }
      })
    }
  };

  const resize = () => {
    const _imgDomInfo = bgImageRef.current.getBoundingClientRect();
    if (!isPhone()) {
      hotspotscontainerRef.current.style.left = _imgDomInfo.left;
    } else {
      hotspotscontainerRef.current.style.left = 0;
    }
    if (window.innerWidth < 768) {
      hotspotscontainerRef.current.style.width = `${_imgDomInfo.width}px`;
      hotspotscontainerRef.current.style.height = '100%';
    } else {
      hotspotscontainerRef.current.style.width = '100%';
      hotspotscontainerRef.current.style.height = `${_imgDomInfo.height}px`;
    }
  };

  React.useEffect(() => {
    window.addEventListener('resize', resize, false);
    resize();
    setTimeout(() => {
      resize();
    }, 260);
    setTimeout(() => {
      resize();
    }, 360);
    setTimeout(() => {
      resize();
    }, 560);
    setTimeout(() => {
      resize();
    }, 760);
    setTimeout(() => {
      resize();
    }, 1060);
    setTimeout(() => {
      resize();
    }, 1360);
    setTimeout(() => {
      resize();
    }, 1460);
    setTimeout(() => {
      resize();
    }, 1860);
    if (isPhone()) {
      setTimeout(() => {
        resize();
      }, 2060);
      setTimeout(() => {
        resize();
      }, 2560);
      setTimeout(() => {
        resize();
      }, 2860);
    }
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  return <div style={{ position: 'absolute', left: 0, top: 60, right: 0, bottom: 0, overflow: 'hidden' }}>
    <Toolbar style={{ padding: '0px 16px' }}>
      <Breadcrumbs>
        <Link onClick={() => {
        }} component={RouteLink} to={'/'}>
          首页
        </Link>
        <Link onClick={() => {
        }} component={RouteLink} to={'/solutions'}>
          解决方案
        </Link>
        {<Link onClick={() => {
        }} component={RouteLink} to={'/solutions/previewDetail/1774bd13a1b84a369d1ec76c1d5487a3'}>
          石化
        </Link>}
        {<Link onClick={() => {
        }} component={RouteLink} to={'/solutions/c68828fbe82e4b26b52d8ba1068feccb'}>
          中游-运输与贮存
        </Link>}
        <Typography>{category?.name}</Typography>;
      </Breadcrumbs>
    </Toolbar>
    <div className={classnames(styles.component_container, (isPhone() || isIPad()) && styles.fixedMinHeight, isPhone() && styles.isPhone)}>
      <img ref={bgImageRef} id="bgimage"
        className={classnames(styles.bgimage, isIPad() && styles.isiPad, isPhone() && styles.isPhone)}
        src={category.cover && category.cover.current && category.cover.current.url} />
      <div id="hotspotscontainer"
        ref={hotspotscontainerRef}
        className={styles.hotspot_container}>
        <div className={styles.hotspot_lists}>
          {
            category.products.map((product, index) => {
              if (typeof product === 'string') return;
              console.log('3 product = ', product);
              const [x, y] = product.overviewName.split(',');
              console.log('x = ', x, 'y = ', y);
              return (
                <div key={index}
                  className={classnames(styles.list_item0, styles['hotspot' + index])}
                  style={{ left: x + '%', bottom: y + '%' }}>
                  <div className={classnames(styles.title, isPhone() && styles.isPhone)}
                    onClick={() => { handleClickFlag(product) }}>
                    <span className={styles.cover}
                      style={{ backgroundImage: `url(${product.cover && product.cover.current && product.cover.current.url})` }}></span>
                    <span className={styles.name}>{product.name}</span>
                  </div>
                  <div className={styles.vertical_line}></div>
                  <div className={styles.circle_dot}>
                    <div className={styles.circle}></div>
                  </div>
                </div>
              );
            })
          }
          {/* {showPopoverDialog &&
            <Dialog
              className={styles.dialog_component}
              data={dialogData}
              pTitle={category.name}
              onDialogClose={this.onDialogClose}
              module={module} />
          } */}
        </div>
      </div>
    </div>
  </div>;
};

export default connect(Preview2DDetail);